import React from "react";
import './UploadTicketImages.css'
import {Bounce, toast} from "react-toastify";

interface UploadTicketImagesProps {
    onBack: () => void,
    selectedImages: any,
    setSelectedImages: (value: any) => void
    goToNextPage: () => void,
}

const MAX_TOTAL_SIZE_MB = 25; // Maximum allowed size for total images (in MB)

const UploadTicketImages: React.FC<UploadTicketImagesProps> = ({onBack, selectedImages, setSelectedImages, goToNextPage}) => {

    const handleFileChange = (event: any) => {
        const files = Array.from(event.target.files); // Convert FileList to Array

        // Validate that all files are images
        const invalidFiles = files.filter((file: any) => !file.type.startsWith('image/'));
        if (invalidFiles.length > 0) {
            toast.error("Algunos archivos no son imágenes válidas. Solo se permiten archivos de imagen.", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return;
        }

        const imageUrls = files.map((file: any) => ({
            file,
            preview: URL.createObjectURL(file), // Create preview URL
            sizeMB: (Math.floor((file.size / (1024 * 1024)) * 10000) / 10000).toFixed(4)  // Convert bytes to MB
        }));

        // Calculate current total size
        const currentTotalSize = selectedImages.reduce((acc: any, img: any) => acc + img.file.size / (1024 * 1024), 0);
        const newFilesSize = files.reduce((acc: any, file: any) => acc + file.size / (1024 * 1024), 0);
        const totalSize = currentTotalSize + newFilesSize;

        // Validate total size doesn't exceed limit
        if (totalSize > MAX_TOTAL_SIZE_MB) {
            toast.error(`El peso total de las imágenes no puede ser mayor a ${MAX_TOTAL_SIZE_MB} MB (peso actual: ${totalSize.toFixed(2)} MB).`, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return;
        }

        setSelectedImages((prevImages: any) => [...prevImages, ...imageUrls]);
    };

    const removeImage = (index: number) => {
        setSelectedImages(selectedImages.filter((_: any, i: number) => i !== index));
    };

    return (
        <div>
            <div className="clients-info-view-header">
                <button onClick={onBack}>REGRESAR</button>
                <div className="clients-info-view-header-title">
                    <p>ADJUNTAR FOTOS</p>
                </div>
            </div>
            <div className="upload-container">
                <div className="upload-buttons-container">
                    <label htmlFor="file-upload" className="custom-file-label">
                        Seleccionar imágenes
                    </label>
                    <input
                        id="file-upload"
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={handleFileChange}
                        className="file-input"
                    />
                    <button className="upload-images-next-button" onClick={goToNextPage}>
                        Siguiente
                    </button>
                </div>
                <div className="image-preview-container">
                    {selectedImages.map((img: any, index: number) => (
                        <div key={index} className="image-wrapper">
                            <img src={img.preview} alt="Selected" className="preview-image"/>
                            <p className="image-size-text">{img.sizeMB} MB</p> {/* Display File Size */}
                            <button onClick={() => removeImage(index)} className="remove-button">
                                ×
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default UploadTicketImages;